import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { ScrollReveal } from "@components/motion/Transitioned"
import { cn } from "@utils/tw"
import { defineBlock, EditableText } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Media",
  icon: "block-default",
  tags: ["#page"],
}

export default defineBlock("content/media", (props) => {
  const items = (props.media ?? [])
    .map((item) => {
      const type =
        item?.type === "video"
          ? "video"
          : item?.type === "image"
            ? "image"
            : item?.video
              ? "video"
              : item?.image
                ? "image"
                : null
      if (type === "video") {
        return {
          type: "video" as const,
          video: item?.video,
        }
      } else if (type === "image") {
        return {
          type: "image" as const,
          image: item?.image,
        }
      }
    })
    .filter((n) => !!n)

  const isSmall = props.style === "small" && items.length === 1

  return (
    <ScrollReveal>
      <div
        className={cn(
          "w-grid mx-auto grid gap-9 md:gap-0 my-10 items-center justify-center md:overflow-hidden",
          isSmall && "md:content-sized md:mx-auto",
          items.length === 1 && "grid-cols-1",
          items.length > 1 && "grid-cols-1 md:grid-cols-2",
          items.length > 2 && "md:gap-6",
        )}
      >
        {env.admin && items.length === 0 && (
          <div className="w-full aspect-video flex items-center justify-center bg-grey rounded-xl">
            <p className="type-label-m">No media selected</p>
          </div>
        )}
        {items.map((item, index) => (
          <div
            key={index}
            className={cn(
              "w-full flex flex-col gap-4 justify-start items-start",
              index === 2 && "md:!ml-[6em]",
              index === 3 && "md:!ml-[10em]",
            )}
            data-transition="scale"
          >
            <div
              className={cn(
                "w-full overflow-hidden rounded-lg",
                items.length > 1 && "aspect-[4/3]",
                index === 1 && "md:rounded-xl",
                index === 2 && "md:!aspect-[2/1]",
                index >= 2 && "md:rounded-full",
                index === 3 && "md:!w-1/2 md:!aspect-square",
              )}
            >
              {item.type === "video" && item.video && (
                <video
                  className="w-full h-full object-cover object-center block"
                  src={item.video.mediaItemUrl || ""}
                  autoPlay
                  playsInline
                  muted
                  loop
                />
              )}
              {item.type === "image" && item.image && (
                <ResponsiveImage {...item.image} className="w-full h-full" objectFit="cover" />
              )}
              {!item.video && !item.image && env.admin && (
                <div className="w-full h-full flex items-center justify-center bg-grey">
                  <p className="type-label-m">No media selected</p>
                </div>
              )}
            </div>
            <EditableText
              as="p"
              store={`mediaCaption-${index}`}
              className={cn("type-label-m mt-2", "w-full")}
              placeholder="Enter a caption for the media"
            />
          </div>
        ))}
      </div>
    </ScrollReveal>
  )
})
